import { Proteins, FreezeDriedProteins } from 'models/Pet'
import { NutritionFrozen, NutritionFreezeDried } from 'models/Nutrition'

export const NUTRITION_PATTIES: Record<Proteins, NutritionFrozen> = {
  [Proteins.BEEF]: {
    protein: Proteins.BEEF,
    caloriesPerOunce: 51,
    caloriesPerKilo: 1800,
    crudeFatPercent: 10.0,
    crudeFiberPercent: 1.0,
    crudeProteinPercent: 12.2,
    moisturePercent: 68.8,
    ingredients:
      'Beef, Beef Liver, Beef Kidney, Beef Bone, Flaxseed, Zinc Sulfate, Vitamin E Supplement, Manganese Sulfate, Vitamin D3 Supplement, Salt',
  },
  [Proteins.CHICKEN]: {
    protein: Proteins.CHICKEN,
    caloriesPerOunce: 47,
    caloriesPerKilo: 1650,
    crudeFatPercent: 10.0,
    crudeFiberPercent: 1.0,
    crudeProteinPercent: 13.0,
    moisturePercent: 71.0,
    ingredients:
      'Chicken, Chicken Hearts, Chicken Liver, Flaxseed, Zinc Sulfate, Vitamin E Supplement, Manganese Sulfate, Vitamin D3 Supplement, Salt',
  },
  [Proteins.LAMB]: {
    protein: Proteins.LAMB,
    caloriesPerOunce: 51,
    caloriesPerKilo: 1800,
    crudeFatPercent: 9.5,
    crudeFiberPercent: 1.0,
    crudeProteinPercent: 13.9,
    moisturePercent: 69.5,
    ingredients:
      'Lamb, Beef, Beef Liver, Beef Kidney, Beef Bone, Flaxseed, Zinc Sulfate, Vitamin E Supplement, Manganese Sulfate, Vitamin D3 Supplement, Salt',
  },
  [Proteins.TURKEY]: {
    protein: Proteins.TURKEY,
    caloriesPerOunce: 47,
    caloriesPerKilo: 1650,
    crudeFatPercent: 6.6,
    crudeFiberPercent: 1.0,
    crudeProteinPercent: 12.8,
    moisturePercent: 73.7,
    ingredients:
      'Turkey, Turkey Gizzards, Turkey Bone, Turkey Liver, Flaxseed, Zinc Sulfate, Vitamin E Supplement, Manganese Sulfate, Vitamin D3 Supplement, Salt',
  },
  [Proteins.VENISON]: {
    protein: Proteins.VENISON,
    caloriesPerOunce: 51,
    caloriesPerKilo: 1450,
    crudeFatPercent: 9.0,
    crudeFiberPercent: 1.0,
    crudeProteinPercent: 13.0,
    moisturePercent: 69.4,
    ingredients:
      'Venison, Beef Heart, Beef Liver, Beef Kidney, Beef Necks (with bone), WFR vitamin + mineral mix [Ground flaxseed, Zinc sulfate, Vitamin E, Manganese sulfate, Vitamin D3], Salt',
  },
  [Proteins.DUCK]: {
    protein: Proteins.DUCK,
    caloriesPerOunce: 47,
    caloriesPerKilo: 1650,
    crudeFatPercent: 10.6,
    crudeFiberPercent: 1.0,
    crudeProteinPercent: 12.6,
    moisturePercent: 71.5,
    ingredients:
      'Duck, Turkey Gizzards, Turkey, Turkey Liver, Flaxseed, Zinc Sulfate, Vitamin E Supplement, Manganese Sulfate, Vitamin D3 Supplement, Salt',
  },
}

export const NUTRITION_FREEZE_DRIED: Record<FreezeDriedProteins, NutritionFreezeDried> = {
  [Proteins.BEEF]: {
    protein: Proteins.BEEF,
    caloriesPerCup: 183,
    caloriesPerOunce: 129,
    caloriesPerKilo: 4534,
    crudeFatPercent: 29.0,
    crudeFiberPercent: 5.0,
    crudeProteinPercent: 36.0,
    moisturePercent: 6.0,
    ingredients:
      'Beef, Beef Liver, Beef Kidney, Beef Spleen, Pumpkin Seeds, Carrots, Apples, Sweet Potato, Butternut Squash, Montmorillonite Clay, Ground Flaxseed, Ground Miscanthus Grass, Salmon Oil, Vitamins (Vitamin E Supplement, Thiamine Mononitrate, Vitamin D3 Supplement), Salt, Tricalcium Phosphate, Potassium Chloride, Minerals (Zinc Proteinate, Copper Proteinate, Manganese Proteinate, Calcium Iodate), Mixed Tocopherols (for freshness), Blueberries, Spinach, Rosemary Extract.',
  },
  [Proteins.CHICKEN]: {
    protein: Proteins.CHICKEN,
    caloriesPerCup: 191,
    caloriesPerOunce: 191,
    caloriesPerKilo: 4534,
    crudeFatPercent: 33.0,
    crudeFiberPercent: 5.0,
    crudeProteinPercent: 36.0,
    moisturePercent: 6.0,
    ingredients:
      'Chicken (including Ground Chicken Bone), Chicken Liver, Chicken Heart, Pumpkin Seeds, Carrots, Apples, Sweet Potato, Butternut Squash, Montmorillonite Clay, Ground Flaxseed, Ground Miscanthus Grass, Salmon Oil,  Vitamins (Vitamin E Supplement, Thiamine Mononitrate, Vitamin D3 Supplement), Potassium Chloride, Tricalcium Phosphate, Salt, Choline Chloride, Minerals (Zinc Proteinate, Copper Proteinate, Manganese Proteinate, Calcium Iodate), DL-Methionine, Mixed Tocopherols (for freshness), Blueberries, Spinach, Rosemary Extract',
  },
}
